import script from "./MaterialLogicMindMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaterialLogicMindMap.vue?vue&type=script&lang=ts&setup=true"

import "./MaterialLogicMindMap.vue?vue&type=style&index=0&id=4850866e&lang=css"

const __exports__ = script;

export default __exports__